
import Vue from "vue";
import PolicyConfigV2 from "@/views/setup/return-policy/PolicyConfigV2.vue";

export default Vue.extend({
    name: "ReturnPolicyIndex",
    components: {
        PolicyConfigV2,
    },
});
